export default "__VITE_ASSET__80d865e8__"